import { useEffect } from 'react'
import AuthService from '../services/auth.service'
import { isNullOrUndefined } from '../common/Helpers'

const useDomainListForgotPw = (domainList, setDomainList) => {
    useEffect(() => {
        const getDomainList = async () => {
            try {
                const serviceResponse = await AuthService.getDomainsFPw();
                const response = serviceResponse.data;

                const _data = response.data.map(item => ({ key: item, name: item }));

                setDomainList && setDomainList(_data)
            }
            catch (error) {
                setDomainList([])
            }
        }

        if (domainList === null) {
            getDomainList()
        }

    }, [domainList, setDomainList])

    return { domainList }
}

const useDomainList = (email, domainList, setDomainList, fireGetDomains, setFireGetDomains, recaptchaToken) => {
    useEffect(() => {
        const getDomainList = async () => {
            try {
                const serviceResponse = await AuthService.getDomains(email, recaptchaToken);
                const response = serviceResponse.data;

                const _data = response.data.map(item => ({ key: item, name: item }));

                setFireGetDomains && setFireGetDomains(false)
                setDomainList && setDomainList(_data)
            }
            catch (error) {
                setFireGetDomains && setFireGetDomains(false)
                setDomainList([])
            }
        }

        if (domainList === null && fireGetDomains === true && !isNullOrUndefined(recaptchaToken)) {
            getDomainList()
        }

    }, [email, domainList, setDomainList, fireGetDomains, setFireGetDomains, recaptchaToken])

    return { domainList }
}

export {
    useDomainListForgotPw,
    useDomainList,
}
